(function () {
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const BASE = ROOT.replace(/\/$/, '');

  const CFG = {
    endpoint: BASE + '/search/suggest.json',
    searchPage: BASE + '/search',
    fields: 'title,product_type,variants.title,variants.sku,vendor,body,tag',
    limit: 8,
    minChars: 2,
    debounce: 180
  };

  const state = { panel: null, input: null, items: [], active: -1, token: 0, q: '', cache: new Map() };
  const skuCache = new Map();

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(v) {
    if (v == null || v === '') return '';
    const raw = String(v);
    const cents = raw.indexOf('.') === -1;
    let n = parseFloat(raw.replace(/[^0-9.\-]/g, ''));
    if (isNaN(n)) return '';
    if (cents) n = n / 100;
    const code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  function terms(q) {
    return q.toLowerCase().split(/\s+/).filter(function (t) { return t.length > 1; });
  }

  function stripHtml(html) {
    return String(html || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function fitmentLine(product, q) {
    const body = stripHtml(product.body);
    if (!body) return '';
    const t = terms(q);
    if (!t.length) return '';
    const lower = body.toLowerCase();
    let idx = -1;
    for (let i = 0; i < t.length; i++) {
      idx = lower.indexOf(t[i]);
      if (idx > -1) break;
    }
    if (idx === -1) return '';
    const start = Math.max(0, idx - 45);
    const slice = (start > 0 ? '…' : '') + body.slice(start, start + 150).trim() + '…';
    return esc(slice);
  }

  function pickSku(skus, q) {
    if (!skus || !skus.length) return '';
    const t = terms(q);
    for (let i = 0; i < skus.length; i++) {
      const low = String(skus[i]).toLowerCase();
      for (let j = 0; j < t.length; j++) {
        if (low.indexOf(t[j]) > -1) return skus[i];
      }
    }
    return skus[0];
  }

  function paintSku(handle) {
    if (!state.panel || state.panel.hidden) return;
    const skus = skuCache.get(handle);
    const sel = '[data-dkis-sku="' + (window.CSS && CSS.escape ? CSS.escape(handle) : handle) + '"]';
    const el = state.panel.querySelector(sel);
    if (!el) return;
    const sku = pickSku(skus, state.q);
    if (sku) el.textContent = 'SKU ' + sku;
  }

  function enrich(products) {
    products.forEach(function (p) {
      if (!p.handle) return;
      if (skuCache.has(p.handle)) { paintSku(p.handle); return; }
      fetch(BASE + '/products/' + encodeURIComponent(p.handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          const skus = (d && d.variants ? d.variants : [])
            .map(function (v) { return v.sku; })
            .filter(Boolean);
          skuCache.set(p.handle, skus);
          paintSku(p.handle);
        })
        .catch(function () { skuCache.set(p.handle, []); });
    });
  }

  function thumb(product) {
    const src = product.featured_image ? product.featured_image.url : product.image;
    if (!src) return '<span class="dkis-thumb dkis-thumb--empty" aria-hidden="true"></span>';
    const sized = src.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2');
    return '<img class="dkis-thumb" src="' + esc(sized) + '" alt="" loading="lazy" width="60" height="60">';
  }

  function buildPanel() {
    const el = document.createElement('div');
    el.className = 'dkis-panel';
    el.setAttribute('role', 'listbox');
    el.hidden = true;
    document.body.appendChild(el);
    el.addEventListener('mousedown', function (e) { e.preventDefault(); });
    return el;
  }

  function place() {
    if (!state.panel || !state.input || state.panel.hidden) return;
    const r = state.input.getBoundingClientRect();
    state.panel.style.top = window.scrollY + r.bottom + 6 + 'px';
    state.panel.style.left = window.scrollX + r.left + 'px';
    state.panel.style.width = Math.max(r.width, 320) + 'px';
  }

  function close() {
    if (!state.panel) return;
    state.panel.hidden = true;
    state.items = [];
    state.active = -1;
    if (state.input) state.input.setAttribute('aria-expanded', 'false');
  }

  function open(html) {
    if (!state.panel) return;
    state.panel.innerHTML = html;
    state.panel.hidden = false;
    state.items = Array.prototype.slice.call(state.panel.querySelectorAll('[data-dkis-item]'));
    state.active = -1;
    if (state.input) state.input.setAttribute('aria-expanded', 'true');
    place();
  }

  function render(products, q) {
    if (!products.length) {
      return '<div class="dkis-empty">No parts match “' + esc(q) + '”. Try a year, make, model or part number.</div>';
    }
    const rows = products.map(function (p, i) {
      const fit = fitmentLine(p, q);
      const price = money(p.price != null ? p.price : p.price_min);
      const inStock = p.available !== false;
      const stock =
        '<span class="dkis-stock ' + (inStock ? 'dkis-stock--in' : 'dkis-stock--out') + '">' +
        (inStock ? 'In stock' : 'Out of stock') +
        '</span>';
      return (
        '<a class="dkis-row" data-dkis-item id="dkis-opt-' + i + '" role="option" href="' + esc(p.url) + '">' +
        thumb(p) +
        '<span class="dkis-body">' +
        '<span class="dkis-title">' + esc(p.title) + '</span>' +
        '<span class="dkis-meta">' +
        '<span class="dkis-sku" data-dkis-sku="' + esc(p.handle) + '"></span>' +
        stock +
        '</span>' +
        (fit ? '<span class="dkis-fit">' + fit + '</span>' : '') +
        '</span>' +
        (price ? '<span class="dkis-price">' + esc(price) + '</span>' : '') +
        '</a>'
      );
    }).join('');
    const all = '<a class="dkis-all" data-dkis-item href="' + CFG.searchPage + '?q=' + encodeURIComponent(q) + '&type=product">See all results for “' + esc(q) + '”</a>';
    return '<div class="dkis-list">' + rows + '</div>' + all;
  }

  function url(q) {
    return CFG.endpoint +
      '?q=' + encodeURIComponent(q) +
      '&resources[type]=product' +
      '&resources[limit]=' + CFG.limit +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=' + encodeURIComponent(CFG.fields);
  }

  function query(q) {
    const token = ++state.token;
    if (state.cache.has(q)) {
      const cached = state.cache.get(q);
      state.q = q;
      open(render(cached, q));
      enrich(cached);
      return;
    }
    fetch(url(q), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (token !== state.token) return;
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        state.cache.set(q, products);
        state.q = q;
        open(render(products, q));
        enrich(products);
      })
      .catch(function () {
        if (token !== state.token) return;
        open('<div class="dkis-empty">Search is unavailable right now. Press Enter to run a full search.</div>');
      });
  }

  function move(dir) {
    if (!state.items.length) return;
    state.items.forEach(function (el) { el.classList.remove('is-active'); });
    state.active += dir;
    if (state.active < 0) state.active = state.items.length - 1;
    if (state.active >= state.items.length) state.active = 0;
    const el = state.items[state.active];
    el.classList.add('is-active');
    el.scrollIntoView({ block: 'nearest' });
    if (state.input) state.input.setAttribute('aria-activedescendant', el.id || '');
  }

  function attach(input) {
    if (input.dataset.dkisBound) return;
    input.dataset.dkisBound = '1';
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');

    let timer;

    input.addEventListener('input', function () {
      state.input = input;
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < CFG.minChars) { close(); return; }
      timer = setTimeout(function () { query(q); }, CFG.debounce);
    });

    input.addEventListener('focus', function () {
      state.input = input;
      const q = input.value.trim();
      if (q.length >= CFG.minChars) query(q);
    });

    input.addEventListener('keydown', function (e) {
      if (state.panel && state.panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && state.active > -1) {
        e.preventDefault();
        state.items[state.active].click();
      }
    });

    input.addEventListener('blur', function () {
      setTimeout(close, 120);
    });
  }

  function scan() {
    document.querySelectorAll('.dk-search input[name="q"]').forEach(attach);
  }

  function init() {
    state.panel = buildPanel();
    scan();
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('scroll', place, { passive: true });
    window.addEventListener('resize', place);
    document.addEventListener('click', function (e) {
      if (state.panel && !state.panel.contains(e.target) && e.target !== state.input) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
